import React, { Fragment } from "react";
import utils from "@utils";
import { PAY_RATE_TYPE } from "@constants";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ReactSelect } from "../../../../../components";

const PositionSummaryForm = props => {
	const minStartDate = new Date().toISOString().split("T")[0];
	const { lang } = global;
	const dateMask = [/[0-1]/, /[0-9]/, "/", /[0-3]/, /[0-9]/, "/", /2/, /0/, /[2-9]/, /[0-9]/];
	const {
		positionName,
		isPositionValid,
		handlePositionChanges,
		savePosition,
		officersNeeded,
		isJobEvent,
		positionStartDate,
		positionStartTime,
		positionEndTime,
		user,
		militaryTimeMask,
		generalInfoStartTime,
		generalInfoEndTime,
		formatPositionTime,
		PayCodesEnabled,
		IsPayCodeMandatory,
		positionRate,
		officerRate,
		PayCodeId,
		handleSelectChange,
		agencyPayCodes,
		agencyPTAEOCodes,
		onCancel,
		saveButtonText,
		cancelButtonText,
		sortOrder,
		positionRateRadioName,
		isReportingPositon,
		handleCheckboxChange,
		applyPTAEOcode,
		PTAEOCodeId,
	} = props;

	const positionRateOptions = [
		{ value: PAY_RATE_TYPE.HOURLY, label: lang.t("Hourly Rate") },
		{ value: PAY_RATE_TYPE.PAY_CODE, label: lang.t("Pay Code") },
	];

	return (
		<Fragment>
			<div className="row v-align">
				<div className="col-xs-12">
					<div className="row">
						<div
							className={classNames("col-sm-6 form-group", {
								"invalid-field": positionName.trim() === "" && !isPositionValid,
							})}
						>
							<label htmlFor={`positionName-${sortOrder}`}>
								{lang.t("Position Name")}
							</label>
							<span className="required-mark" />
							<input
								name="positionName"
								id={`positionName-${sortOrder}`}
								className="form-control"
								placeholder="Position Name"
								value={positionName}
								onChange={handlePositionChanges}
								onKeyPress={e => {
									if (e.key === "Enter") savePosition();
								}}
								data-test-id="jobs__position-name"
							/>
						</div>
						<If condition={PayCodesEnabled && !IsPayCodeMandatory}>
							<div className={classNames("col-xs-12 col-sm-3 form-group")}>
								<label htmlFor={`position-payCode-id-${sortOrder}`}>
									{lang.t("Pay Type")}
									<span className="required-mark" />
								</label>
								<ReactSelect
									id={`position-payCode-id-${sortOrder}`}
									data-test-id="jobs__position-rate-type"
									value={positionRate}
									name={positionRateRadioName}
									onChange={e => handleSelectChange(e, positionRateRadioName)}
									options={positionRateOptions}
									isLoading={false}
									onKeyPress={e => {
										if (e.key === "Enter") savePosition();
									}}
									className="react-select__control"
								/>
							</div>
						</If>
						<Choose>
							<When condition={positionRate === PAY_RATE_TYPE.HOURLY}>
								<div
									className={classNames("col-xs-12 col-sm-3 form-group", {
										"invalid-field":
											(!officerRate ||
												officerRate.toString().trim() === "") &&
											!isPositionValid,
									})}
								>
									<label htmlFor={`officerRate-${sortOrder}`}>
										{lang.t("Rate/Hr")}
									</label>
									<span className="required-mark" />
									<div className="input-group">
										<div className="input-group-addon">$</div>
										<input
											name="officerRate"
											id={`officerRate-${sortOrder}`}
											data-test-id="jobs__officer-rate"
											className="form-control"
											placeholder="Rate"
											value={officerRate}
											onChange={handlePositionChanges}
											onKeyPress={e => {
												if (e.key === "Enter") savePosition();
											}}
										/>
									</div>
								</div>
							</When>
							<Otherwise>
								<div
									className={classNames("col-xs-12 col-sm-3 form-group", {
										"invalid-field": !PayCodeId && !isPositionValid,
									})}
								>
									<label htmlFor={`position-payCode-id-${sortOrder}`}>
										{lang.t("Pay Code")}
										<span className="required-mark" />
									</label>
									<ReactSelect
										id={`position-payCode-id-${sortOrder}`}
										dataTestId="jobs__position-pay-code"
										value={PayCodeId}
										name="PayCodeId"
										onChange={e => handleSelectChange(e, "PayCodeId")}
										options={agencyPayCodes}
										isLoading={false}
										onKeyPress={e => {
											if (e.key === "Enter") savePosition();
										}}
										className="react-select__control"
									/>
								</div>
							</Otherwise>
						</Choose>
					</div>
				</div>
				<div className="col-xs-12">
					<div className="row">
						<div
							className={classNames("col-xs-12 col-sm-3 form-group", {
								"invalid-field":
									(officersNeeded.toString().trim() === "" ||
										officersNeeded.toString().trim() === "0") &&
									!isPositionValid,
							})}
						>
							<label htmlFor={`officersNeeded-${sortOrder}`}>
								{lang.t("Officers Needed")}
							</label>
							<span className="required-mark" />
							<input
								name="officersNeeded"
								id={`officersNeeded-${sortOrder}`}
								data-test-id="jobs__officers-needed"
								className="form-control"
								placeholder="1"
								value={officersNeeded}
								onChange={handlePositionChanges}
								onKeyPress={e => {
									if (e.key === "Enter") savePosition();
								}}
							/>
						</div>
						<If condition={isJobEvent}>
							<div
								className={classNames("col-xs-12 col-sm-3 form-group", {
									"invalid-field":
										positionStartDate.trim() === "" && !isPositionValid,
								})}
							>
								<label htmlFor={`positionStartDate-${sortOrder}`}>
									{lang.t("Date")}
								</label>
								<span className="required-mark" />
								<Choose>
									<When condition={utils.isDesktopSafari || utils.isIE}>
										<MaskedInput
											name="positionStartDate"
											id={`positionStartDate-${sortOrder}`}
											data-test-id="jobs__position-start-date"
											type="text"
											mask={dateMask}
											className="form-control"
											placeholder="mm/dd/yyyy"
											value={positionStartDate}
											disabled={!!isReportingPositon}
											onChange={handlePositionChanges}
											onKeyPress={e => {
												if (e.key === "Enter") savePosition();
											}}
										/>
									</When>
									<Otherwise>
										<input
											name="positionStartDate"
											id={`positionStartDate-${sortOrder}`}
											data-test-id="jobs__position-start-date"
											className="form-control"
											type="date"
											value={positionStartDate}
											disabled={!!isReportingPositon}
											onChange={handlePositionChanges}
											onKeyPress={e => {
												if (e.key === "Enter") savePosition();
											}}
											min={minStartDate}
										/>
									</Otherwise>
								</Choose>
							</div>
							<div
								className={classNames("col-xs-12 col-sm-3 form-group", {
									"invalid-field":
										positionStartTime.trim() === "" &&
										isJobEvent &&
										!isPositionValid,
								})}
							>
								<Choose>
									<When condition={isJobEvent}>
										<label htmlFor={`positionStartTime-${sortOrder}`}>
											{lang.t("Start Time")}
										</label>
										<span className="required-mark" />
										<Choose>
											<When
												condition={
													user.UserPreferences !== "useMilitaryTime"
												}
											>
												<input
													type="time"
													name="positionStartTime"
													id={`positionStartTime-${sortOrder}`}
													className="form-control"
													value={positionStartTime}
													onChange={handlePositionChanges}
													onKeyPress={e => {
														if (e.key === "Enter") savePosition();
													}}
													disabled={!isJobEvent}
												/>
											</When>
											<Otherwise>
												<MaskedInput
													type="text"
													name="positionStartTime"
													id={`positionStartTime-${sortOrder}`}
													mask={militaryTimeMask}
													className="form-control"
													placeholder="hh:mm"
													value={positionStartTime}
													onChange={handlePositionChanges}
													onKeyPress={e => {
														if (e.key === "Enter") savePosition();
													}}
													disabled={!isJobEvent}
												/>
											</Otherwise>
										</Choose>
									</When>
									<Otherwise>
										<If condition={generalInfoStartTime !== ""}>
											<label htmlFor={`positionStartTime-${sortOrder}`}>
												{lang.t("Start Time")}
											</label>
										</If>
										<Choose>
											<When condition={utils.isDesktopSafari || utils.isIE}>
												<div>{generalInfoStartTime}</div>
											</When>
											<Otherwise>
												<If condition={generalInfoStartTime !== ""}>
													<div>
														{formatPositionTime(generalInfoStartTime)}
													</div>
												</If>
											</Otherwise>
										</Choose>
									</Otherwise>
								</Choose>
							</div>
							<div
								className={classNames("col-xs-12 col-sm-3 form-group", {
									"invalid-field":
										positionEndTime.trim() === "" &&
										isJobEvent &&
										!isPositionValid,
								})}
							>
								<Choose>
									<When condition={isJobEvent}>
										<label htmlFor={`positionEndTime-${sortOrder}`}>
											{lang.t("End Time")}
										</label>
										<span className="required-mark" />
										<Choose>
											<When
												condition={
													user.UserPreferences !== "useMilitaryTime"
												}
											>
												<input
													type="time"
													name="positionEndTime"
													id={`positionEndTime-${sortOrder}`}
													className="form-control"
													value={positionEndTime}
													onChange={handlePositionChanges}
													onKeyPress={e => {
														if (e.key === "Enter") savePosition();
													}}
													disabled={!isJobEvent}
												/>
											</When>
											<Otherwise>
												<MaskedInput
													type="text"
													name="positionEndTime"
													id={`positionEndTime-${sortOrder}`}
													mask={militaryTimeMask}
													className="form-control"
													placeholder="hh:mm"
													value={positionEndTime}
													onChange={handlePositionChanges}
													onKeyPress={e => {
														if (e.key === "Enter") savePosition();
													}}
													disabled={!isJobEvent}
												/>
											</Otherwise>
										</Choose>
									</When>
									<Otherwise>
										<If condition={generalInfoEndTime !== ""}>
											<label htmlFor={`positionEndTime-${sortOrder}`}>
												{lang.t("End Time")}
											</label>
										</If>
										<Choose>
											<When condition={utils.isDesktopSafari || utils.isIE}>
												<div>{generalInfoEndTime}</div>
											</When>
											<Otherwise>
												<If condition={generalInfoEndTime !== ""}>
													<div>
														{formatPositionTime(generalInfoEndTime)}
													</div>
												</If>
											</Otherwise>
										</Choose>
									</Otherwise>
								</Choose>
							</div>
						</If>
					</div>
				</div>
				<div className="col-xs-12">
					<div className="row">
						<div
							className="row"
							style={{ margin: "0", padding: "0" }}
						>
							<If condition={user.Organization.UsePTAEOCode}>
								<div className="col-xs-12 col-sm-12 checkbox">
									<label htmlFor={`applyPTAEOcode-${sortOrder}`}>
										<input
											type="checkbox"
											name="applyPTAEOcode"
											id={`applyPTAEOcode-${sortOrder}`}
											data-test-id="jobs__apply-ptaeo-organization-code"
											checked={applyPTAEOcode}
											onChange={handleCheckboxChange}
										/>
										{lang.t("Apply PTAEO Code")}
									</label>
								</div>
							</If>
							<If condition={applyPTAEOcode}>
								<div
									className={classNames("col-xs-12 col-sm-6 form-group", {
										"invalid-field": !PTAEOCodeId && !isPositionValid,
									})}
								>
									<label htmlFor={`position-ptaeoCode-id-${sortOrder}`}>
										{lang.t("PTAEO Code")}
										<span className="required-mark" />
									</label>
									<ReactSelect
										id={`position-ptaeoCode-id-${sortOrder}`}
										dataTestId="jobs__position-ptaeo-code"
										value={PTAEOCodeId?.toString()}
										name="PTAEOCodeId"
										onChange={e => handleSelectChange(e, "PTAEOCodeId")}
										options={agencyPTAEOCodes}
										isLoading={false}
										onKeyPress={e => {
											if (e.key === "Enter") savePosition();
										}}
										className="react-select__control"
									/>
								</div>
							</If>
						</div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-xs-12 text-right">
					<If condition={onCancel}>
						<button
							type="button"
							className="btn btn-link"
							onClick={() => onCancel()}
							data-test-id="jobs__position-cancel"
						>
							{cancelButtonText}
						</button>
					</If>
					<button
						type="button"
						className="btn btn-link"
						onClick={() => savePosition(true)}
						data-test-id="jobs__position-save"
					>
						{saveButtonText}
					</button>
				</div>
			</div>
		</Fragment>
	);
};

PositionSummaryForm.propTypes = {
	positionName: PropTypes.string.isRequired,
	isPositionValid: PropTypes.bool.isRequired,
	handlePositionChanges: PropTypes.func.isRequired,
	savePosition: PropTypes.func.isRequired,
	officersNeeded: PropTypes.any.isRequired,
	isJobEvent: PropTypes.bool.isRequired,
	positionStartDate: PropTypes.string.isRequired,
	positionStartTime: PropTypes.string.isRequired,
	positionEndTime: PropTypes.string.isRequired,
	user: PropTypes.any.isRequired,
	militaryTimeMask: PropTypes.func.isRequired,
	generalInfoStartTime: PropTypes.string.isRequired,
	generalInfoEndTime: PropTypes.string.isRequired,
	formatPositionTime: PropTypes.func.isRequired,
	PayCodesEnabled: PropTypes.bool.isRequired,
	IsPayCodeMandatory: PropTypes.bool.isRequired,
	positionRate: PropTypes.number.isRequired,
	positionRateRadioName: PropTypes.string.isRequired,
	handleSelectChange: PropTypes.func.isRequired,
	handleCheckboxChange: PropTypes.func.isRequired,
	agencyPayCodes: PropTypes.array.isRequired,
	agencyPTAEOCodes: PropTypes.array.isRequired,
	onCancel: PropTypes.func.isRequired,
	saveButtonText: PropTypes.string.isRequired,
	sortOrder: PropTypes.number.isRequired,
	applyPTAEOcode: PropTypes.bool.isRequired,
	PayCodeId: PropTypes.any,
	PTAEOCodeId: PropTypes.any,
	officerRate: PropTypes.any,
	cancelButtonText: PropTypes.string,
	isReportingPositon: PropTypes.any,
};

PositionSummaryForm.defaultProps = {
	PayCodeId: null,
	PTAEOCodeId: null,
	officerRate: 0,
	cancelButtonText: "",
	isReportingPositon: false,
};

export default PositionSummaryForm;
